import { PermissionType } from '@golden/gdk-base';
import { AlertInfo } from '../enums/AlertInfo';
export const alertInfoMapPermission = {
    [AlertInfo.DEPOSIT_WAY_FULL_CASH_REACHED]: PermissionType.ALERT_RECORD_DEPOSIT_WAY_FULL_CASH_REACHED,
    [AlertInfo.TRANSFER_STATUS_NOT_MATCH]: PermissionType.ALERT_RECORD_TRANSFER_STATUS_NOT_MATCH,
    [AlertInfo.NO_TRANSFER_LOG_IN_THIRD_PARTY]: PermissionType.ALERT_RECORD_NO_TRANSFER_LOG_IN_THIRD_PARTY,
    [AlertInfo.BET_REVENUE_3W]: PermissionType.ALERT_RECORD_BET_REVENUE_3W,
    [AlertInfo.TRC_BIND]: PermissionType.ALERT_RECORD_TRC_BIND,
    [AlertInfo.REAL_NAME_DUPLICATE]: PermissionType.ALERT_RECORD_REAL_NAME_DUPLICATE,
    [AlertInfo.RC_WARNED_USER_GAME_LOGIN]: PermissionType.ALERT_RECORD_RC_WARNED_USER_GAME_LOGIN,
    [AlertInfo.WITHDRAW_REVENUE_3W]: PermissionType.ALERT_RECORD_WITHDRAW_REVENUE_3W,
    [AlertInfo.WALLET_DUPLICATE]: PermissionType.ALERT_RECORD_WALLET_DUPLICATE,
    [AlertInfo.DEPOSIT_ORDER_CREATING_TOO_FREQUENTLY]: PermissionType.ALERT_RECORD_DEPOSIT_ORDER_CREATING_TOO_FREQUENTLY,
    [AlertInfo.LOCATION_NOT_MATCH]: PermissionType.ALERT_RECORD_LOCATION_NOT_MATCH,
    [AlertInfo.DUPLICATE_FINGERPRINT]: PermissionType.ALERT_RECORD_DUPLICATE_FINGERPRINT_READ
};
//# sourceMappingURL=alertInfoMapPermission.js.map